import Vue from "vue";
Vue.component('PriceIndicatorCell', require('./components/ads/PriceIndicatorCell.vue').default);
Vue.component('AutotraderResponseCell', require('./components/ads/AutotraderResponseCell.vue').default);
Vue.component('FundingStatusCell', require('./components/finance/funding/FundingStatusCell.vue').default);
Vue.component('IconButtonCell', require('./components/finance/funding/IconButtonCell.vue').default);
Vue.component('AdsMenuCell', require('./components/ads/MenuCell.vue').default);
Vue.component('StockListingJobStatusCell', require('./components/vehicles/StockListingJobStatusCell.vue').default);
Vue.component('FundingMenuCell', require('./components/finance/funding/MenuCell.vue').default);
Vue.component('FinanceContraCell', require('./components/finance/FinanceContraCell.vue').default);
